import { api } from './base';
import { InternalSite } from './site_admin.api';

export interface AuditLog {
  id: number;
  site_id: number;
  employee_id: number;
  tag: string;
  message: string;
  raw?: string;
  employee_name?: string;
  site_title?: string;
  create_time: string;
  item_id: string;
}

export interface AuditLogQuery {
  siteId?: number;
  employeeId?: number;
  tag?: string;
  itemId?: string;
  skip?: number;
  limit?: number;
  startTime?: string;
  endTime?: string;
}

export interface LogsResult {
  logs: Array<AuditLog>;
  sites: Array<InternalSite>;
  total: number;
}

export const auditLogApis = {
  search(query?: AuditLogQuery) {
    let url = `/admin/audit-logs?`;
    if (query) {
      const params = [];
      if (query.siteId || query.siteId === 0) {
        params.push(`site_id=${query.siteId}`);
      }
      if (query.employeeId) {
        params.push(`employee_id=${query.employeeId}`);
      }
      if (query.tag) {
        params.push(`tag=${query.tag}`);
      }
      if (query.itemId) {
        params.push(`item_id=${query.itemId}`);
      }
      if (query.skip) {
        params.push(`skip=${query.skip}`);
      }
      if (query.limit) {
        params.push(`limit=${query.limit}`);
      }
      if (query.startTime && query.endTime) {
        // 大坑，flask会自动去除+号，发送的时候必须进行url编码
        const startTime = encodeURIComponent(query.startTime);
        const endTime = encodeURIComponent(query.endTime);
        params.push(`startTime=${startTime}`);
        params.push(`endTime=${endTime}`);
      }
      url += params.join('&');
    }
    return api.get<LogsResult>(url);
  }
};
